var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"social-link",attrs:{"href":_vm.socialLink(_vm.handle),"target":"_blank"},on:{"click":function($event){return _vm.gotoEvent(`visit_user_${_vm.network}`)}}},[(
      typeof this.handle != 'undefined' &&
        this.handle &&
        this.handle.length > 1
    )?_c('div',{staticClass:"social-account"},[_c('i',{class:_vm.socialIcon(_vm.network)}),_vm._v(" "+_vm._s(_vm.socialAccount(_vm.handle))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }